import { useSuspenseQuery } from "@tanstack/react-query"

import { getSubscription } from "../../app/services/billing"

export function useSubscriptionQuery() {
  return useSuspenseQuery({
    queryKey: ["subscription"],
    queryFn: getSubscription,
  })
}
